enum ReservationStepEnum {
  I,
  II,
  III,
  IV,
  V
}

export default ReservationStepEnum;
